import React, {  useEffect } from 'react'
import Routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import ThemeCustomization from 'themes';
import {loadUser} from "store/slices/userLoginAction"
// auth provider
import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
import { store } from 'store'
// ==============================|| APP ||============================== //

const App = () => {
    useEffect(() => {
        if (localStorage.MILITARY_USER_TOKEN) {
        store.dispatch(loadUser())
        }
  
      }, [])
    
   return (
 
    <ThemeCustomization>
        {/* RTL layout */}
        <RTLLayout>
            <Locales>
                <NavigationScroll>
                    <AuthProvider>
                        <>
                            <Routes />
                            <Snackbar />
                        </>
                    </AuthProvider>
                </NavigationScroll>
            </Locales>
        </RTLLayout>
    </ThemeCustomization>
);
}

export default App;
